export enum LoginType {
    FACEBOOK = 'facebook'
}
